// removed by extract-text-webpack-plugin
module.exports = {"holding-lists":"holding-lists___3_xCh center___2iqBf","holding-list":"holding-list___1E1nv shadow-broad___37axf","holding-list-icn-title-flex":"holding-list-icn-title-flex___z6M9E center___2iqBf","holding-list-icn":"holding-list-icn___3WexR","holding-list-no-icn":"holding-list-no-icn___2cegM","holding-list-title-label":"holding-list-title-label___1vpw- h4___kHWTn","holding-list-title":"holding-list-title___2N20Z h2___hzLuT","holding-list-item":"holding-list-item___pZLtk center___2iqBf","holding-list-item-title":"holding-list-item-title___2XwZA h2___hzLuT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesHoldingsLists/TargetDateSeriesHoldingsLists.css
// module id = 930
// module chunks = 0